document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector(".header-menu-mobile-toggle");

  if (menuToggle) {
    menuToggle.addEventListener("click", () => {
      const menu = document.querySelector(".mobile-menu");
      menu.classList.toggle("expanded");

      document.body.classList.toggle("overflow-hidden");

      document.querySelector(".header-menu-open").classList.toggle("hidden");
      document.querySelector(".header-menu-close").classList.toggle("hidden");

    });
  }

  const dropdowns = document.querySelectorAll(".header-menu-item--dropdown");

  function toggleDropdown(dropdown) {
    const dropdownContent = dropdown.nextElementSibling;
    dropdownContent.classList.toggle("hidden");
    dropdownContent.classList.toggle("flex");
    dropdownContent.classList.toggle("h-0");
    dropdownContent.classList.toggle("h-auto");
    dropdown.querySelector("span").classList.toggle("rotate-180");
  }
  
  function openDropdown(dropdown) {
    const dropdownContent = dropdown.nextElementSibling;
    dropdownContent.classList.remove("hidden");
    dropdownContent.classList.add("flex");
    dropdownContent.classList.remove("h-0");
    dropdownContent.classList.add("h-auto");
    dropdown.querySelector("span").classList.remove("rotate-180");
  }

  function closeDropdown(dropdown) {
    const dropdownContent = dropdown.nextElementSibling;
    dropdownContent.classList.add("hidden");
    dropdownContent.classList.remove("flex");
    dropdownContent.classList.add("h-0");
    dropdownContent.classList.remove("h-auto");
    dropdown.querySelector("span").classList.remove("rotate-180");
  }

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("click", () => {
      toggleDropdown(dropdown);
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".header-menu-item--dropdown")) {
      const dropdowns = document.querySelectorAll(".header-menu-item--dropdown");
      dropdowns.forEach((dropdown) => {
        closeDropdown(dropdown);
      });
    }
  });

  const searchToggles = document.querySelectorAll(".search-toggle");
  searchToggles.forEach((searchToggle) => {
    searchToggle.addEventListener("click", () => {
      const search = document.querySelector("div.search");
      search.classList.toggle("expanded");
      
      // Initialize and show predictive search component when overlay opens
      const predictiveSearchComponent = document.querySelector("predictive-search-component");
      if (predictiveSearchComponent && search.classList.contains("expanded")) {
        // Force component to show and set default state
        predictiveSearchComponent.show();
        predictiveSearchComponent.setState('default');
        
        // Focus on search input for better UX
        setTimeout(() => {
          const searchInput = document.querySelector('.search input[name="q"]');
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      }
    });
  });

  // Handle search close button
  const searchClose = document.querySelector(".search-close");
  if (searchClose) {
    searchClose.addEventListener("click", (e) => {
      e.preventDefault();
      closeSearchOverlay();
    });
  }

  // Handle close-outside button for search overlay
  const searchOverlay = document.querySelector("div.search");
  if (searchOverlay) {
    const closeOutside = searchOverlay.querySelector(".close-outside");
    if (closeOutside) {
      closeOutside.addEventListener("click", (e) => {
        e.preventDefault();
        closeSearchOverlay();
      });
    }
  }

  // Function to close search overlay and hide component
  function closeSearchOverlay() {
    const search = document.querySelector("div.search");
    search.classList.remove("expanded");
    
    // Hide predictive search component when overlay closes
    const predictiveSearchComponent = document.querySelector("predictive-search-component");
    if (predictiveSearchComponent) {
      predictiveSearchComponent.hide();
    }
  }

  // Handle Escape key to close search overlay
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const searchOverlay = document.querySelector("div.search");
      if (searchOverlay && searchOverlay.classList.contains('expanded')) {
        event.preventDefault();
        closeSearchOverlay();
      }
    }
  });
});